export var SearchResultType;
(function (SearchResultType) {
    SearchResultType["department"] = "department";
    SearchResultType["userprofile"] = "userprofile";
    SearchResultType["resource"] = "resource";
    SearchResultType["tag"] = "tag";
    SearchResultType["taggedposts"] = "taggedposts";
    SearchResultType["group"] = "group";
    SearchResultType["recent"] = "recent";
})(SearchResultType || (SearchResultType = {}));
export var UserRole;
(function (UserRole) {
    UserRole["user"] = "user";
    UserRole["trainer"] = "trainer";
    UserRole["admin"] = "admin";
})(UserRole || (UserRole = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJvZmlsZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZG9tYWluL1Byb2ZpbGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVVBLE1BQU0sQ0FBTixJQUFZLGdCQVFYO0FBUkQsV0FBWSxnQkFBZ0I7SUFDMUIsNkNBQXlCLENBQUE7SUFDekIsK0NBQTJCLENBQUE7SUFDM0IseUNBQXFCLENBQUE7SUFDckIsK0JBQVcsQ0FBQTtJQUNYLCtDQUEyQixDQUFBO0lBQzNCLG1DQUFlLENBQUE7SUFDZixxQ0FBaUIsQ0FBQTtBQUNuQixDQUFDLEVBUlcsZ0JBQWdCLEtBQWhCLGdCQUFnQixRQVEzQjtBQWtCRCxNQUFNLENBQU4sSUFBWSxRQUlYO0FBSkQsV0FBWSxRQUFRO0lBQ2xCLHlCQUFhLENBQUE7SUFDYiwrQkFBbUIsQ0FBQTtJQUNuQiwyQkFBZSxDQUFBO0FBQ2pCLENBQUMsRUFKVyxRQUFRLEtBQVIsUUFBUSxRQUluQiJ9